import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
} from "@chakra-ui/react";
import ModalBlurOverlay from "components/Shared/ModalBlurOverlay";
import { SetupGuideBody, SetupGuideHeader } from "./SetupGuide";
import { OnboardingSetupStep } from "./SetupStepTile";

type Props = {
  completedCount: number | undefined;
  isOpen: boolean;
  onClose: () => void;
  steps: OnboardingSetupStep[];
};

export default function SetupModal({
  completedCount,
  isOpen,
  onClose,
  steps,
}: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
      <ModalBlurOverlay />
      <ModalContent>
        <ModalHeader>
          <SetupGuideHeader completedCount={completedCount} steps={steps} />
        </ModalHeader>

        <ModalCloseButton aria-label="Close setup" />

        <ModalBody pb={6}>
          <SetupGuideBody
            completedCount={completedCount}
            onStepClick={onClose}
            steps={steps}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
